import { useWizard } from "react-use-wizard";
import React, { useEffect, useState } from "react";
import NavigateBack from "../../components/navigateBack";
import TermsCondtions from "../../components/termsCondtions";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";

function TermsConditionsStep({ qKey, question, onSubmitHandler, state }) {
  const { previousStep, nextStep } = useWizard();
  const _qKey = qKey;

  const onNextFn = (data) => {
    onSubmitHandler({ [_qKey]: data });
    nextStep();
  };

  const onBackFn = () => {
    previousStep();
  };

  return (
    <>
      <NavigateBack onClickHandler={onBackFn} />
      <TermsCondtions
        question={question}
        onSubmitHandler={onNextFn}
        state={state}
      />
    </>
  );
}

export default TermsConditionsStep;
